import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74e9eda5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM21.9459 5.5L15.6173 12.6983L22.5 22.5H17.4379L12.8028 15.8996L6.99977 22.5H5.5L12.137 14.9514L5.5 5.5H10.5621L14.9511 11.7502L20.4463 5.5H21.9459ZM12.8907 14.0936L13.5632 15.0347L18.1434 21.4455H20.447L14.8341 13.5896L14.1617 12.6485L9.84371 6.60473H7.54016L12.8907 14.0936Z"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "icon-twitter",
    width: _ctx.px,
    height: _ctx.px,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 8, _hoisted_1))
}